import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import GuestNavbar from '../navigation/guestnavbar.jsx'
import SecurityAwareness from '../securityawareness/securityawareness.jsx'
import DefaulNavbar from '../navigation/defaultnavbar.jsx';
import LeftLink from '../leftlink/leftlink.jsx'

class componentName extends Component {
 
    render() {
        
        return (
            <div className="m-0 p-0">
                {localStorage.getItem("loginState") === "true" ?
                    <div className="row m-0 p-0" >
                        <div className="col-sm-12 m-0 p-0">
                            <AuthNavbar />
                        </div>
                        <div className="container" style={{ }}>
                            <div className="row">
                                {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                    <LeftLink />
                                </div> */}
                                <div className="col-sm-12" style={{ padding: "0px 30px" }}>

                                    <div className="row articles-pages" style={{ padding: "12px 0px", minHeight: "476px" }}>
                                        <SecurityAwareness />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="col-sm-12">
                            <DefaulNavbar />
                        </div>
                        <div className="container" style={{ marginTop: "80px" }}>
                            <div className="row articles-pages">
                                <SecurityAwareness />
                            </div>
                        </div>
                    </div>}
            </div>
        );
    }
}

export default componentName;


// WEBPACK FOOTER //
// ./src/components/authpages/security.jsx